import { getVertexId } from '../../core/util';
import type { CoreTypes } from '../../core';
import type { Types as SduiTypes } from '../types';

export default (
  settings: CoreTypes.Mixed.Settings,
  options:  SduiTypes.options
): SduiTypes.hour => {
  return {
    id:             getVertexId(settings, options),
    name:           '',
    time_begins_at: settings.dayStart,
    time_ends_at:   settings.dayEnd,
  };
};
